module.exports = __webpack_public_path__ + "static/media/cactusCover.815c9089.svg";